import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import ContactSidebar from '../components/ContactSidebar';
import MainSidebar from '../components/MainSidebar';
import Footer from '../components/Footer';
import config from '../config/config';

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [statusMessage, setStatusMessage] = useState('');
  const [error, setError] = useState('');
  const [address, setAddress] = useState('');
  const [showMainSidebar, setShowMainSidebar] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-site-settings`);
        if (response.data.success) {
          setAddress(response.data.data.address);
        } else {
          setError('Failed to fetch site settings.');
        }
      } catch (err) {
        setError('Failed to fetch site settings.');
      }
    };

    const fetchUserDetails = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }

      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (response.data.success) {
          const { name, email } = response.data.data.user;
          setFormData(prevFormData => ({
            ...prevFormData,
            name,
            email
          }));
        } else {
          setError('Failed to fetch user details.');
        }
      } catch (err) {
        setError('Failed to fetch user details.');
      }
    };

    fetchSettings();
    fetchUserDetails();

    // Check for token to decide which sidebar to show
    const token = localStorage.getItem('token');
    setShowMainSidebar(!!token);
  }, []);

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage('');
    setError('');
  
    try {
      const response = await axios.post(`${config.baseURL}/contact-us`, formData);
      if (response.data.success) {
        setStatusMessage('Your message has been sent successfully.');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
  
        // Clear the success message after 3 seconds
        setTimeout(() => {
          setStatusMessage('');
        }, 3000); // 3000ms = 3 seconds
      } else {
        setError(response.data.message || 'Failed to send your message. Please try again later.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send your message. Please try again later.');
    }
  };
  useEffect(() => {
    // Scroll to top when this component is loaded
    window.scrollTo(0, 0);
  }, []);  

  return (
    <div>
      <div className="main_patreonpass_wrapper contact_page">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            {showMainSidebar ? <MainSidebar /> : <ContactSidebar />}
          </div>
          <div className="patreonpass_main_content" id="content">
            <div className="left_main_content full_width_right_bar">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown create_post_page payment_cards contactpage_heading">
                  <div className="page_heading">
                    <button className="profile_back_btn create_post_btn" onClick={handleBackClick}>
                      <svg
                        width={54}
                        height={54}
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                          stroke="#222"
                          strokeWidth={6}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <h1>Contact</h1>
                  </div>
                </div>
                <div className="contact_block_wrapper add_card_block">
                  <p>
                    If you have any questions, please fill out the form below to contact us.
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            maxLength={30}
                            placeholder=""
                          />
                          <label htmlFor="name" className="placeholder-label">
                            Enter your name
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            maxLength={25}
                            placeholder=""
                          />
                          <label htmlFor="email" className="placeholder-label">
                            Enter your e-mail
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <select
                            className="form-control"
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                          >
                            <option value="">Select subject</option>
                            <option>Registration and Verification</option>
                            <option>Profile Access</option>
                            <option>Credit Card Payments</option>
                            <option>Payouts</option>
                            <option>Cancel my payout request</option>
                            <option>Technical Questions</option>
                            <option>Reporting Stolen Content</option>
                            <option>Law Enforcement / Legal Matter</option>
                            <option>Report Illegal Material or Behavior</option>
                            <option>Creator Suggestions and Feedback</option>
                            <option>Other</option>
                          </select>
                          <label htmlFor="subject" className="placeholder-label active_label">
                            Select subject
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative text_area_contact">
                          <textarea
                            rows={5}
                            className="form-control"
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder=""
                          />
                          <label htmlFor="message" className="placeholder-label">
                            Enter your message
                          </label>
                        </div>
                        <div className="word_count" id="wordCount">
                          {formData.message.length} / 2000
                        </div>
                      </div>
                    </div>
                    <div className="submit_btn">
                      <button type="submit" className="create_post_btn_area post_btn">
                        Submit
                      </button>
                    </div>
                  </form>
                  {statusMessage && <p className="success alert_message alert-success mt-2">{statusMessage}</p>}
                  {error && <p className="error_message alert alert-danger">{error}</p>}
                  <div className="form_bottom_text">
                    {address}
                  </div>
                  <div className="b-line-hr mb-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

    </div>

  );
};

export default Contact;
